module.exports = __webpack_public_path__ + "static/mobilenotification-purpose-dont-531c517fd826c32aec37e09b610bcbec.png";